<!-- <div *ngIf="loadingData" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Body with tabs following F7004 pattern -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active">
      <div class="form-horizontal">
        @if (loadingData) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!loadingData) {
<div>

        <!-- Entity information table -->
        <table class="table table-bordered form-inline enityDetails custom-table">
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.key }}</span>
            </td>
}
          </tr>
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.value }}</span>
            </td>
}
          </tr>
        </table>
        
        <!-- Form Content -->
        <div class="form-content">
          
          <!-- Table Header -->
          <table class="table table-bordered custom-table">
            <tr>
              <td>{{tableHeader[0].description}}:
                <div>   
                  <input 
                    class="form-control input-md numText text_field_width" 
                    type="text" 
                    maxlength="19" 
                    [(ngModel)]="tableHeader[0].value" 
                    [disabled]="true">
                </div>
              </td>
              <td>{{tableHeader[1].description}}:
                <div>   
                  <input 
                    class="form-control input-md numText text_field_width" 
                    type="text" 
                    maxlength="10" 
                    [(ngModel)]="tableHeader[1].value" 
                    [disabled]="true">
                </div>
              </td> 
            </tr>
          </table>

          <!-- Main Form Table -->
          <table class="I_Entry table table-bordered form-inline custom-table">
            <thead>
              <tr>
                <th colspan="10">{{modalTitle}}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of form1125EView; track itemTracker($index, row)) {
<tr 
                class="formDataBlock" 
               >
                
                <!-- Line Number -->
                <td>{{row.num}}</td>
                
                <!-- Description and Controls -->
                <td class="descBlock">
                  <span>{{row.description}}</span>
                  
                  <!-- Dropdown for line 1 -->
                  @if (row.num == '1') {
<span>
                    <select 
                      id="system_chart" 
                      class="form-control" 
                      name="status" 
                      [(ngModel)]="form1125EView[0].value_1"
                      (change)="updateColumnB(form1125EView[0].value_1)">
                      <option value="" disabled>Please Select</option>
                      @for (s of formLOV; track itemTracker($index, s)) {
<option 
                        
                        [value]="s.CODE_DESC">
                        {{s.CODE_DESC}}
                      </option>
}
                    </select> 
                  </span>
}
                  
                  <!-- Conditional text input for "Other" option -->
                  @if (row.num == '1' && row.conditionalField) {
<input 
                    type="text" 
                    maxlength="75" 
                    [(ngModel)]="row.value_user_input" 
                    [name]="row.num" 
                    
                    (change)="updateField(row.num, row.data_type, form1125EView[0].value_1)" 
                    class="form-control input-sm">
}
                </td>
                
                <!-- Value Input -->
                <td style="width: 200px;" align="right">
                  <!-- Number input -->
                  @if (row.data_type == 'number') {
<div 
                    style="width: 200px;" 
                   >
                    <input 
                      style="font-size: 14px" 
                      type="text" 
                      [disabled]="row.disableField" 
                      format="number" 
                      maxlength="15" 
                      [ngClass]="{'color-red': row.value < 0}" 
                      [(ngModel)]="row.value" 
                      (change)="updateField(row.num, row.data_type, form1125EView[0].value_1)" 
                      [name]="row.num" 
                      class="form-control input-sm">
                  </div>
}
                  
                  <!-- Text input -->
                  @if (row.data_type == 'text' || row.data_type == 'string') {
<div 
                    style="width: 200px;" 
                   >
                    <input 
                      style="font-size: 14px" 
                      type="text" 
                      [disabled]="row.disableField" 
                      maxlength="50" 
                      [(ngModel)]="row.value" 
                      (change)="updateField(row.num, row.data_type, form1125EView[0].value_1)" 
                      [name]="row.num" 
                      class="form-control input-sm">
                  </div>
}
                </td>
                
              </tr>
}
            </tbody>
          </table>

        </div>

        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div> 